module.exports = __webpack_public_path__ + "media/assets/images/leanbit_home/soluzioni_personalizzate_slider-cc51b3ceafb20c7e546c64158dfb9c7b.png";